import React, { useEffect, useState, useRef } from "react";
import "./styles.css";
import { Button, Input, message, Popover, Drawer, Modal, Dropdown } from "antd";
import { fetchEventSource } from "../../utils/fetch-event-source";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import wx from "weixin-js-sdk";

import SwitchCloseIcon from "../../assets/switch-close.svg";
import SwitchOpenIcon from "../../assets/switch-open.svg";
import CreateNewChat from "../../assets/create-icon.png";
import MoreIcon from "../../assets/opreation-more.png";
import EditorIcon from "../../assets/editor.svg";
import DeleteIcon from "../../assets/delete.png";
import PhoneMenuIcon from "../../assets/phone-menu.png";
import PhoneReturnIcon from "../../assets/phone-return.png";
import PlayIcon from "../../assets/play-icon.png";
import ShareIcon from "../../assets/share-icon.png";
import LikeIcon from "../../assets/like-icon.svg";
import UnLikeIcon from "../../assets/unlike-icon.svg";
import RecordIcon from "../../assets/record-icon.png";
import CloseIcon from "../../assets/close-icon.png";
import ReferencesIcon from "../../assets/references-icon.png";
import LanguageIcon from "../../assets/language-icon.png";
import RecordingIcon from "../../assets/recording.gif";
import DownVoteActiveIcon from "../../assets/unlike-active-icon.svg";
import LikeActiveIcon from "../../assets/licke-active-icon.svg";
import PauseIcon from "../../assets/pause.png";
import { ReactComponent as CreateNewIcon } from "../../assets/create-new-icon.svg";
import { ReactComponent as LinkIcon } from "../../assets/link-icon.svg";
import { ReactComponent as CopyIcon } from "../../assets/copy-icon.svg";
import { ReactComponent as FreshIcon } from "../../assets/fresh-icon.svg";
import { ReactComponent as AddIconMobile } from "../../assets/add-phone.svg";
import { useTranslation } from "react-i18next";

import LanguageSwitcher from "../../components/LanguageSwitcher.jsx";

const { TextArea } = Input;

let recognizer;
let voiceText = "";

const SendIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath id="master_svg0_31_10331">
          <rect x="0" y="0" width="30" height="30" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_10331)">
        <g>
          <path
            d="M3.75,16.249784765625L11.25,16.249784765625L11.25,13.749784765625L3.75,13.749784765625L3.75,2.306884765625C3.75,1.961709765625,4.029825,1.681884765625,4.375,1.681884765625C4.480312,1.681884765625,4.583925,1.708497365625,4.6762,1.759247265625L27.7542,14.452184765625C28.0567,14.618484765625,28.1671,14.998584765625,28.0007,15.301084765625C27.9436,15.404884765625,27.8581,15.490384765625,27.7542,15.547584765625L4.6762,28.240384765625C4.37375,28.406784765625,3.993712,28.296384765625,3.8273624,27.994084765625C3.7766126,27.901684765625,3.75,27.798184765625,3.75,27.692784765625L3.75,16.249784765625Z"
            fill="#FFFFFF"
            fillOpacity="1"
            style={{ mixBlendMode: "passthrough" }}
          />
        </g>
      </g>
    </svg>
  );
};
const SendIconSmall = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <defs>
        <clipPath id="master_svg0_31_23267">
          <rect x="0" y="0" width="16" height="16" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_23267)">
        <g>
          <path
            d="M2,8.666522656249999L6,8.666522656249999L6,7.33318265625L2,7.33318265625L2,1.23030565625C2,1.04621265625,2.14924,0.89697265625,2.333333,0.89697265625C2.3895,0.89697265625,2.44476,0.91116605625,2.493973,0.93823265625L14.8023,7.70778265625C14.9636,7.79652265625,15.0225,7.99918265625,14.9337,8.16052265625C14.9033,8.215922656250001,14.8577,8.261522656250001,14.8023,8.29198265625L2.493973,15.06147265625C2.332667,15.15027265625,2.12998,15.09137265625,2.0412599,14.93007265625C2.0141934,14.88087265625,2,14.82567265625,2,14.76947265625L2,8.666522656249999Z"
            fill="#FFFFFF"
            fillOpacity="1"
            style={{ mixBlendMode: "passthrough" }}
          />
        </g>
      </g>
    </svg>
  );
};
const CustomerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="50"
      height="50.000003814697266"
      viewBox="0 0 50 50.000003814697266"
    >
      <defs>
        <clipPath id="master_svg0_31_35016">
          <rect x="0" y="0" width="50" height="50.000003814697266" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_35016)">
        <g>
          <ellipse
            cx="24.375"
            cy="24.375"
            rx="19.375"
            ry="19.375"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
        <g>
          <path
            d="M25,0C38.8,0,50,11.2,50,25C50,38.8,38.8,50,25,50C11.2,50,0,38.8,0,25C0,11.2,11.2,0,25,0ZM10.0583,33.5407C13.7271,39.0173,19.2378,42.5,25.3993,42.5C31.5607,42.5,37.0715,39.0173,40.7402,33.5407C36.7212,29.793,31.328,27.5,25.3993,27.5C19.4705,27.5,14.0774,29.793,10.0583,33.5407ZM25,22.5C29.1423,22.5,32.5,19.1421,32.5,15C32.5,10.8579,29.1423,7.5,25,7.5C20.8577,7.5,17.5,10.8579,17.5,15C17.5,19.1421,20.8577,22.5,25,22.5Z"
            fill="#919499"
            fill-opacity="1"
          />
        </g>
      </g>
    </svg>
  );
};
const CustomerIconMobile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="40"
      height="40.000003814697266"
      viewBox="0 0 40 40.000003814697266"
    >
      <defs>
        <clipPath id="master_svg0_31_34986">
          <rect x="0" y="0" width="40" height="40.000003814697266" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_34986)">
        <g>
          <ellipse
            cx="19.5"
            cy="19.5"
            rx="15.5"
            ry="15.5"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
        <g>
          <path
            d="M20,0C31.04,0,40,8.96,40,20C40,31.04,31.04,40,20,40C8.96,40,0,31.04,0,20C0,8.96,8.96,0,20,0ZM8.04664,26.8326C10.9817,31.2138,15.3902,34,20.3194,34C25.2486,34,29.6572,31.2138,32.5922,26.8326C29.377,23.8344,25.0624,22,20.3194,22C15.5764,22,11.2619,23.8344,8.04664,26.8326ZM20,18C23.3138,18,26,15.3137,26,12C26,8.6863,23.3138,6,20,6C16.6862,6,14,8.6863,14,12C14,15.3137,16.6862,18,20,18Z"
            fill="#919499"
            fill-opacity="1"
          />
        </g>
      </g>
    </svg>
  );
};
const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <defs>
        <clipPath id="master_svg0_31_23287">
          <rect x="0" y="0" width="24" height="24" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_31_23287)">
        <g>
          <path
            d="M12,22C6.47715,22,2,17.5228,2,12C2,6.47715,6.47715,2,12,2C17.5228,2,22,6.47715,22,12C22,17.5228,17.5228,22,12,22ZM11,11L7,11L7,13L11,13L11,17L13,17L13,13L17,13L17,11L13,11L13,7L11,7L11,11Z"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
      </g>
    </svg>
  );
};

const PC = () => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    // 获取微信JS-SDK配置
    const fetchWechatConfig = async () => {
      try {
        const response = await fetch(
          "https://wechat.cgtn.com/socialweb/social/weixin/getKeys.do?url=" +
            encodeURIComponent(window.location.href.split("#")[0]),
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("获取微信配置成功:", data);
        // 初始化微信JS-SDK配置
        wx.config({
          debug: false, // 开启调试模式
          appId: "wxd61ff47456d31b8e",
          timestamp: data.data.timestamp,
          nonceStr: data.data.nonceStr,
          signature: data.data.signature,
          jsApiList: [
            "checkJsApi",
            "updateAppMessageShareData",
            "updateTimelineShareData",
          ],
        });

        // 处理配置成功
        wx.ready(() => {
          console.log("微信JS-SDK配置成功");
          const shareData = {
            title: "Chinapedia AI",
            desc: "Ask me anything about China!",
            link: window.location.href,
            imgUrl:
              "https://chinapedia.goclouds.cn/event/2025/Chinapedia-AI/logo.png",
            success: () => console.log("分享配置成功"),
            cancel: () => console.log("用户取消分享"),
          };

          // 检查JS API可用性
          wx.checkJsApi({
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
            success: (res) => console.log("JS API检查结果:", res),
          });

          // 设置分享到朋友圈
          wx.updateTimelineShareData(shareData);

          // 设置分享给朋友
          wx.updateAppMessageShareData(shareData);
        });

        // 处理配置失败
        wx.error((err) => {
          console.error("微信JS-SDK配置失败:", err);
        });
      } catch (error) {
        console.error("获取微信配置失败:", error);
      }
    };

    // 执行配置获取
    fetchWechatConfig();
  }, []);
  const controllerRef = useRef(null);
  const controllerRef1 = useRef(null);
  const chatDivRef = useRef(null);
  const tipList = [
    {
      id: 1,
      title: t("tip.culture"),
      content: t("tip.culture.content"),
    },
    {
      id: 2,
      title: t("tip.travel"),
      content: t("tip.travel.content"),
    },
    {
      id: 3,
      title: t("tip.technology"),
      content: t("tip.technology.content"),
    },
    {
      id: 4,
      title: t("tip.nature"),
      content: t("tip.nature.content"),
    },
    {
      id: 5,
      title: t("tip.economy"),
      content: t("tip.economy.content"),
    },
    {
      id: 6,
      title: t("tip.history"),
      content: t("tip.history.content"),
    },
  ];
  const [inputValue, setInputValue] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openSwitch, setOpenSwitch] = useState(false); //是否展开侧边栏
  const [editorStatus, setEditorStatus] = useState(false); //是否编辑历史问题名称
  const [drawerOpen, setDrawerOpen] = useState(false); //是否展开移动端侧边栏
  const [isLongPress, setIsLongPress] = useState(false);
  const [showBubblePhone, setShowBubblePhone] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); //移动端重命名弹窗
  const [shareModalOpenPhone, setShareModalOpenPhone] = useState(false); //移动端分享弹窗
  const [shareAgentData, setShareAgentData] = useState([]); //当前分享的数据
  const [editorValue, setEditorValue] = useState(""); //当前修改问题值
  const [chatIdSelect, setChatIdSelect] = useState(""); //当前对话的ID
  const [nameValue, setNameValue] = useState(""); //重命名回显值
  const [nameValueData, setNameValueData] = useState(null); //重命名数据
  const [historyList, setHistoryList] = useState([]); //当前页面聊天历史记录
  const firstHandled = useRef(false); // 标记是否已经处理过第一次消息
  const [currentPlaying, setCurrentPlaying] = useState(null); // 当前播放的 audioUrl
  const audioRef = useRef(null);
  const [langText, setLangText] = useState(null); // 当前语言
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState(null); // 当前语言
  const languageMap = {
    en: "en-US",
    zh: "zh-CN",
    ar: "ar-SA",
    es: "es-ES",
    fr: "fr-FR",
    ru: "ru-RU",
  };
  const languageTextMap = {
    en: "English",
    zh: "中文",
    ar: "العربية",
    es: "Español",
    fr: "Français",
    ru: "Русский",
  };
  const items = [
    {
      key: "1",
      label: "中文",
    },
    {
      key: "2",
      label: "English",
    },
    {
      key: "3",
      label: "Español",
    },
    {
      key: "4",
      label: "Français",
    },
    {
      key: "5",
      label: "Русский",
    },
    {
      key: "6",
      label: "العربية",
    },
  ];
  const current = (
    localStorage.getItem("language") ||
    i18n.resolvedLanguage ||
    i18n.language ||
    "en"
  ).split("-")[0];

  // 录音转文字
  const [inputText, setInputText] = useState("");
  // 是否在录音
  const [isListening, setIsListening] = useState(false);
  // 是否是移动端
  const [isMobile, setIsMobile] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false); //删除会话提示
  const [deleteData, setDeleteData] = useState(null); //删除会话提示
  const [openPopoverId, setOpenPopoverId] = useState(null);
  const [pauseChatStatus, setPauseChatStatus] = useState(false); //是否暂停会话
  const inputRef = useRef(null); // 引用输入框
  const [isComposing, setIsComposing] = useState(false); // 是否处于中文输入中

  const CodeBlock = ({ node, inline, className, children, ...props }) => {
    const match = /language-(\w+)/.exec(className || "");
    return !inline && match ? (
      <SyntaxHighlighter
        style={tomorrow}
        language={match[1]}
        PreTag="div"
        {...props}
      >
        {String(children).replace(/\n$/, "")}
      </SyntaxHighlighter>
    ) : (
      <code className={className} {...props}>
        {children}
      </code>
    );
  };

  useEffect(() => {
    // 监听语言切换
    const handleLanguageChange = (lng) => {
      // 页面始终保持 LTR，不因阿拉伯语变 RTL
      document.documentElement.setAttribute("dir", "ltr");
      document.documentElement.setAttribute("lang", lng);
    };
    // 立即执行一次，保证初始加载时也正确
    handleLanguageChange(
      (
        localStorage.getItem("language") ||
        i18n.resolvedLanguage ||
        i18n.language ||
        "en"
      ).split("-")[0],
    );

    // 监听 i18n 语言变化事件
    i18n.on("languageChanged", handleLanguageChange);
    // 清理监听器
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);
  // 将 base64 转换成 Blob URL
  const base64ToBlobUrl = (base64Data, mimeType = "audio/wav") => {
    // 如果包含 data:audio/xxx;base64, 头部，先去掉
    let cleaned = base64Data;
    if (base64Data.includes(",")) {
      cleaned = base64Data.split(",")[1];
    }

    // 清理可能存在的换行符或空格
    cleaned = cleaned.replace(/\s/g, "");

    // 解码 base64 -> 二进制
    const byteString = atob(cleaned);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ia], { type: mimeType });
    return URL.createObjectURL(blob);
  };

  const useAudioQueue = (onQueueEnd) => {
    const audioQueueRef = useRef([]); // [{ url, msgId }]
    const currentAudioRef = useRef(null);
    const currentMsgIdRef = useRef(null); // 新增：当前播放的 msgId
    const isAudioEnabledRef = useRef(true); // ✅ 是否允许接收播放新音频

    // 播放队列
    const playNext = async () => {
      if (audioQueueRef.current.length === 0) {
        currentMsgIdRef.current = null; // 队列为空时清空当前 msgId
        return;
      }

      const { url, msgId } = audioQueueRef.current.shift();
      const audio = new Audio(url);
      currentAudioRef.current = audio;
      currentMsgIdRef.current = msgId; // 设置当前播放的 msgId

      audio.onended = () => {
        currentAudioRef.current = null;

        if (audioQueueRef.current.length === 0) {
          // 队列空了 → 通知外部对应 msgId 的播放完成
          if (onQueueEnd) onQueueEnd(msgId);
          currentMsgIdRef.current = null; // 清空当前 msgId
        }

        playNext(); // 继续下一条
      };

      try {
        await audio.play();
      } catch (err) {
        console.error("音频播放失败:", err);
        playNext(); // 播放失败时继续下一个
      }
    };

    // 添加音频到队列（带 msgId）
    const enqueueAudio = (url, msgId) => {
      if (!isAudioEnabledRef.current) return; // ✅ 如果暂停播放，不接收新音频
      audioQueueRef.current.push({ url, msgId });

      if (!currentAudioRef.current) {
        playNext();
      }
    };

    const pause = () => {
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
      }
      isAudioEnabledRef.current = false; // ✅ 停止接收新音频
    };

    const stop = () => {
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
        currentAudioRef.current = null;
      }
      audioQueueRef.current = [];
      currentMsgIdRef.current = null; // 清空当前 msgId
      isAudioEnabledRef.current = false; // ✅ 暂停接收新音频
    };

    const resume = () => {
      isAudioEnabledRef.current = true; // ✅ 允许继续接收
      // if (!currentAudioRef.current && audioQueueRef.current.length > 0) {
      //   playNext();
      // }
    };

    // 新增：获取当前播放的 msgId
    const getCurrentMsgId = () => {
      return currentMsgIdRef.current;
    };

    // 新增：检查是否正在播放指定 msgId
    const isPlayingMsgId = (msgId) => {
      return currentMsgIdRef.current === msgId;
    };

    return {
      enqueueAudio,
      pause,
      stop,
      getCurrentMsgId,
      isPlayingMsgId,
      resume,
    };
  };

  const {
    enqueueAudio,
    stop: stopTTS,
    getCurrentMsgId,
    isPlayingMsgId,
    resume: resumeTTS,
  } = useAudioQueue((finishedMsgId) => {
    // 队列播放完成 → 把对应消息 isPlaying 改为 false
    setChatHistory((prev) => {
      const newHistory = [...prev];
      const index = newHistory.findIndex(
        (item) => item.msgId === finishedMsgId,
      );
      if (index !== -1) {
        newHistory[index] = {
          ...newHistory[index],
          isPlaying: false,
        };
      }
      return newHistory;
    });
  });

  const detectLanguage = (text) => {
    if (/[\u0600-\u06FF]/.test(text)) {
      return "ar"; // 阿拉伯语
    }
    return "unknown";
  };
  const startChat = (msg = "", type = "new") => {
    if (isLoading || (msg === "" && inputValue === "")) {
      return;
    }
    // 先停止 useAudioQueue 正在进行的队列播放
    stopTTS();
    setChatHistory((prev) =>
      prev.map((msg) => ({
        ...msg,
        isPlaying: false,
      })),
    );
    if (type === "refresh") {
      setChatHistory((prev) => {
        const newHistory = [...prev];
        newHistory.pop();

        return newHistory;
      });
    }
    const userMsgId = new Date().getTime() + "User";
    let msgId = new Date().getTime() + "Ai";
    if (type === "new") {
      setChatHistory((prev) => [
        ...prev,
        {
          msgId: userMsgId,
          content: msg || inputValue,
          role: "user",
          isEditing: false,
          messageId: "",
          language: detectLanguage(msg || inputValue)
            ? detectLanguage(msg || inputValue)
            : "",
        },
        {
          msgId: msgId,
          content: "",
          role: "system",
          isEditing: false,
          isPlaying: isMobile ? false : true,
          messageId: "",
          documents: "",
          audioUrl: "",
          audioUrls: [], // 新增：初始化音频队列
          isFinished: "",
          like: false,
          downVote: false,
          language: "",
        },
      ]);
    }
    let params = {
      prompt: msg || inputValue,
      chatId: chatIdSelect,
      // chatHistory: chatHistory, // 使用当前的聊天历史
    };
    setInputValue("");
    setIsLoading(true);
    let chatDiv = document.querySelector(".ChatDiv");
    if (chatDiv !== null) {
      setTimeout(() => {
        chatDiv.scrollTop = chatDiv?.scrollHeight;
      }, 100);
    }

    // 如果之前有未结束的流，先中断
    // if (controllerRef1.current) {
    //   controllerRef1.current.abort();
    // }

    const controller1 = new AbortController();
    controllerRef1.current = controller1;

    fetchEventSource(
      // "https://Chinapedia.goclouds.cn/event/2025/Chinapedia-AI/chinapedia/chat/stream",
      // "https://chinapedia-test.goclouds.cn/chat/sseStream",
      "https://www.chinapedia.ai/chat/sseStream",
      // "https://chinapedia-test-v2.goclouds.cn/chat/sseStream",
      // "http://192.168.110.133:8080/chat/sseStream",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
        cache: "no-store",
        openWhenHidden: true,
        signal: controller1.signal,
        async onopen(event) {
          // console.log("onopen", event);
          resumeTTS();
        },
        async onmessage(event) {
          let data = JSON.parse(event.data);
          if (chatDiv !== null) {
            chatDiv.scrollTop = chatDiv.scrollHeight;
          } else {
            chatDiv = document.querySelector(".ChatDiv");
            chatDiv.scrollTop = chatDiv.scrollHeight;
          }

          let audioUrl = "";
          // 生成音频 URL
          if (data.audio) {
            audioUrl = base64ToBlobUrl(data.audio, "audio/mp3");
            if (!isMobile) {
              enqueueAudio(audioUrl, msgId);
            }
          }
          setChatHistory((prev) => {
            const index = prev.findIndex((item) => item.msgId === msgId);
            if (index === -1) {
              if (type === "refresh") {
                return [
                  ...prev,
                  {
                    msgId: msgId,
                    content: data.answer,
                    documents: data.documents,
                    messageId: data.messageId,
                    audioUrl: audioUrl || "",
                    audioUrls: audioUrl ? [audioUrl] : [], // 新增：存成队列
                    role: "system",
                    isEditing: false,
                    isPlaying: isMobile ? false : true,
                    isFinished: data.isFinished,
                    like: false,
                    downVote: false,
                    language: data.language,
                  },
                ];
              } else {
                return [
                  ...prev,
                  {
                    msgId: userMsgId,
                    content: msg || inputValue,
                    messageId: data.messageId,
                    role: "user",
                    isEditing: false,
                  },
                  {
                    msgId: msgId,
                    content: data.answer,
                    documents: data.documents,
                    messageId: data.messageId,
                    audioUrl: audioUrl || "",
                    audioUrls: audioUrl ? [audioUrl] : [], // 新增：存成队列
                    role: "system",
                    isEditing: false,
                    isPlaying: isMobile ? false : true,
                    isFinished: data.isFinished,
                    like: false,
                    downVote: false,
                    language: data.language,
                  },
                ];
              }
            } else {
              const newHistory = [...prev];
              newHistory[index - 1] = {
                ...newHistory[index - 1],
                messageId: data.messageId,
              };
              // 追加文本与音频队列
              const prevItem = newHistory[index];
              const mergedAudioUrls = [
                ...(prevItem.audioUrls || []),
                ...(audioUrl ? [audioUrl] : []),
              ];
              newHistory[index] = {
                ...prevItem,
                content: prevItem.content + data.answer,
                isEditing: prevItem.isEditing || false,
                isPlaying: prevItem.isPlaying || false,
                audioUrl: prevItem.audioUrl || audioUrl || "", // 保持旧字段兼容
                audioUrls: mergedAudioUrls, // 新增：队列累积
                documents: prevItem.documents || data.documents,
                messageId: data.messageId,
                isFinished: data.isFinished,
                like: prevItem.like || false,
                downVote: prevItem.downVote || false,
                language: prevItem.language || data.language,
              };
              chatDiv.scrollTop = chatDiv.scrollHeight;
              return newHistory;
            }
          });
          if (!firstHandled.current && !chatIdSelect) {
            setChatIdSelect(data.chatId);
            firstHandled.current = true; // 标记为已处理
            let params = { prompt: msg || inputValue };
            try {
              const response = await fetch(
                "https://chinapedia-test.goclouds.cn/chat/title",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json", // 告诉后端传递的是 JSON
                  },
                  body: JSON.stringify(params),
                },
              );
              if (!response.ok) {
                console.log("请求失败");
              }

              const result = await response.json();
              const timestamp = Date.now();
              let historyItem = {
                title: result?.title || msg || inputValue,
                chatId: data.chatId,
                editorStatus: false,
                timestamp: timestamp,
              };
              setHistoryList((prev) => {
                const updated = [...prev, historyItem];
                localStorage.setItem(
                  "historyListData",
                  JSON.stringify(updated),
                ); // 同步存储
                const recentData = filterLast7Days(updated);
                const sortedData = [...recentData].sort(
                  (a, b) => b.timestamp - a.timestamp,
                );
                return sortedData;
              });
            } catch (err) {
              console.log(err.message);
            }
          }
        },
        async onerror(event) {
          if (event.name === "AbortError") {
            console.log("SSE 请求已被手动中断");
            return;
          }
          console.log("onerror", event);
          setIsLoading(false);
        },
        async onclose(event) {
          // console.log("onclose", event);
          // 清空输入框
          // setInputValue("");
          setIsLoading(false);
          resumeTTS();
          // controllerRef.current = null;
        },
      },
    );
  };
  // 暂停当前会话流
  const pauseChat = () => {
    setPauseChatStatus(true);
    setIsLoading(false);
    // 停止 SSE 请求
    if (controllerRef1.current) {
      controllerRef1.current.abort();
      controllerRef1.current = null;
    }

    let itemData = chatHistory[chatHistory.length - 1];
    if (isPlayingMsgId(itemData.msgId)) {
      if (controllerRef.current) {
        controllerRef.current.abort(); // 停止流式请求
        controllerRef.current = null;
      }
      stopTTS();
      setChatHistory((prev) =>
        prev.map((msg) =>
          msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
        ),
      );
    }
  };

  useEffect(() => {
    let isMobile = /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
    setIsMobile(isMobile);

    // 初始化时从 localStorage 取
    const stored = localStorage.getItem("historyListData");
    if (stored) {
      const recentData = filterLast7Days(JSON.parse(stored));
      const sortedData = [...recentData].sort(
        (a, b) => b.timestamp - a.timestamp,
      );

      setHistoryList(sortedData);
    }
    const current = (
      localStorage.getItem("language") ||
      i18n.resolvedLanguage ||
      i18n.language ||
      "en"
    ).split("-")[0];
    setLangText(languageTextMap[current]);
    if (current === "zh") {
      setDefaultSelectedKeys("1");
    } else if (current === "en") {
      setDefaultSelectedKeys("2");
    } else if (current === "ar") {
      setDefaultSelectedKeys("6");
    } else if (current === "es") {
      setDefaultSelectedKeys("3");
    } else if (current === "fr") {
      setDefaultSelectedKeys("4");
    } else if (current === "ru") {
      setDefaultSelectedKeys("5");
    }
  }, []);

  // 保留7天数据
  const filterLast7Days = (list) => {
    const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000; // 计算7天前的时间戳
    // const sevenDaysAgo = Date.now() -  60 * 60 * 1000; // 计算7天前的时间戳

    const filteredList = list.filter((item) => {
      return item.timestamp > sevenDaysAgo; // 过滤掉早于7天前的数据
    });

    return filteredList;
  };

  const startRecognition = () => {
    changeVolume();
    const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
      subscriptionKey,
      serviceRegion,
    );
    speechConfig.speechRecognitionLanguage = languageMap[i18n.language]; // 设置语言

    const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
    recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

    recognizer.recognizing = (s, e) => {
      // console.log('--------e.result.text------------',e.result.text);
      // setRecognizedText(e.result.text);
    };

    recognizer.recognized = (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
        voiceText += e.result.text;
        setInputText(voiceText);
        setInputValue(voiceText);
      }
    };

    recognizer.canceled = (s, e) => {
      console.error(`Canceled: ${e.reason}`);
    };

    recognizer.sessionStopped = (s, e) => {
      setIsListening(false);
      recognizer.stopContinuousRecognitionAsync();
      voiceText = "";
    };

    recognizer.startContinuousRecognitionAsync();
    setIsListening(true);
  };
  const stopRecognition = () => {
    setIsListening(false);
    if (recognizer) {
      recognizer.stopContinuousRecognitionAsync();
      voiceText = "";
    }
    resumeTTS();
  };

  // 开启语音转文字，答案播放暂停
  const changeVolume = () => {
    stopTTS();
    // 如果有正在播放的，先停掉
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
    setChatHistory((prev) =>
      prev.map((msg) => ({
        ...msg,
        isPlaying: false,
      })),
    );
  };

  // 是否展开侧边栏
  const changeSwitch = () => {
    setOpenSwitch(!openSwitch);
  };
  // 重命名
  const changeEditorStatus = (historyItem) => {
    setNameValue(historyItem.title);
    setHistoryList((prev) =>
      prev.map((item) => ({
        ...item,
        editorStatus: item.chatId === historyItem.chatId, // 只有被点击的为 true，其余为 false
      })),
    );
    // setEditorStatus(true);
  };
  // 移动端重命名
  const changeEditorStatusPhone = (historyItem) => {
    setShowBubblePhone(false);
    setOpenPopoverId(null);
    setIsModalOpen(true);
    setNameValue(historyItem.title);
    setNameValueData(historyItem);
  };
  // 保存重命名
  const handleOk = () => {
    setIsModalOpen(false);
    setHistoryList((prev) => {
      const updated = prev.map((item) =>
        item.chatId === nameValueData.chatId
          ? { ...item, title: nameValue, editorStatus: false }
          : item,
      );

      // ✅ 保存到 localStorage
      localStorage.setItem("historyListData", JSON.stringify(updated));

      return updated;
    });
    setNameValue("");
    setNameValueData(null);
  };
  // 取消重命名
  const handleCancel = () => {
    setIsModalOpen(false);
    setNameValue("");
    setNameValueData(null);
  };
  // 输入框回车
  const onPressEnter = (e, historyItem) => {
    if (e.key === "Enter") {
      const newValue = e.target.value.trim();
      if (!newValue) return;

      setHistoryList((prev) => {
        const updated = prev.map((item) =>
          item.chatId === historyItem.chatId
            ? { ...item, title: newValue, editorStatus: false }
            : item,
        );

        // ✅ 保存到 localStorage
        localStorage.setItem("historyListData", JSON.stringify(updated));

        return updated;
      });
      setNameValue("");
    }
  };
  // pc端输入框的值
  const handleChangeName = (e) => {
    setNameValue(e.target.value);
  };
  const showDrawer = () => {
    setDrawerOpen(true);
  };
  const onClose = () => {
    setDrawerOpen(false);
  };

  // pc端删除会话历史--移动端删除通用
  const handleDeleteChat = (historyItem) => {
    setDeleteModal(true);
    setDeleteData(historyItem);
    setOpenPopoverId(null);
  };
  const handleCloseDelete = () => {
    setDeleteModal(false);
    setDeleteData(null);
  };
  const handleDelete = () => {
    setHistoryList((prev) => {
      const updated = prev.filter((item) => item.chatId !== deleteData.chatId);

      // ✅ 同步存储到 localStorage
      localStorage.setItem("historyListData", JSON.stringify(updated));

      return updated;
    });
    setDeleteModal(false);
    setDeleteData(null);
    if (chatIdSelect === deleteData.chatId) {
      window.location.reload();
    }
  };

  // 数据重组
  const formatMessages = (chatData) => {
    return chatData.messages.map((msg) => {
      return {
        msgId: msg.msgId, // 保留原始 msgId
        content: msg.content, // 文本内容
        role: msg.user === "assistant" ? "system" : "user", // user => user, assistant => system
        isEditing: false, // 默认 false
        isPlaying: false, // 默认 false
        messageId: msg.messageId || null, // 兼容空值
        documents: msg.documents ? Object.values(msg.documents) : [], // documents 转为数组
        audioUrl: msg.messageId || "", // 单条音频
        audioUrls: msg.audio ? [msg.audio] : [], // 多段音频数组（如果以后支持的话）
        isFinished: true, // 默认已完成
        like: msg.operation === 1 ? true : false, // 默认 false
        downVote: msg.operation === 2 ? true : false, // 默认 false
        history: true, // ✅ 新增字段
        language: msg.language,
      };
    });
  };
  // 选中历史会话
  const handleSelectChat = (historyItem) => {
    onClose();
    setChatIdSelect(historyItem.chatId);
    fetch(
      "https://chinapedia-test.goclouds.cn/history/detail/" +
        historyItem.chatId,
    )
      .then((res) => res.json()) // 解析 JSON
      .then((data) => {
        const formatted = formatMessages(data);
        setChatHistory(formatted);
      })
      .catch((err) => console.error("请求失败:", err));
  };
  // 每次 chatHistory 更新 → 滚动到最底部
  useEffect(() => {
    if (chatDivRef.current) {
      chatDivRef.current.scrollTop = chatDivRef.current.scrollHeight;
    }
  }, [chatHistory.length]);

  const cancelShow = () => {
    setShowBubblePhone(false);
    setIsLongPress(false);
  };

  // 移动端显示分享弹窗
  const showShareModalPhone = (e, item) => {
    e.stopPropagation();
    const data = chatHistory.find(
      (msg) => msg.messageId === item.messageId && msg.role === "user",
    );
    if (data) {
      let newArray = [];
      newArray.push(data);
      newArray.push(item);
      setShareAgentData(newArray);
      setShareModalOpenPhone(true);
    }
  };
  const handleCopy = () => {
    const url = `${window.location.origin}/share?messageId=${shareAgentData[0].messageId}`; // 拼接路由和参数
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          message.success(t("toast.copied"));
        })
        .catch((err) => {
          console.error("复制失败:", err);
          fallbackCopyText(url);
        });
    } else {
      fallbackCopyText(url);
    }
  };
  const fallbackCopyText = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed"; // 避免滚动跳动
    textarea.style.opacity = 0;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      message.success(t("toast.copied"));
    } catch (err) {
      console.error("复制失败:", err);
      message.error("复制失败，请手动复制");
    }
    document.body.removeChild(textarea);
  };

  // 关闭分享弹窗
  const hideShareModalPhone = () => {
    setShareModalOpenPhone(false);
  };

  // pc端点击修改问题
  const handleClickEditor = (itemData) => {
    setEditorValue(itemData.content);
    setChatHistory((prev) => {
      return prev.map((item) => {
        if (item.msgId === itemData.msgId) {
          return {
            ...item,
            isEditing: true,
          };
        }
        return item;
      });
    });
  };
  // 取消修改
  const handleCloseEditor = (itemData) => {
    setEditorValue("");
    setChatHistory((prev) => {
      return prev.map((item) => {
        if (item.msgId === itemData.msgId) {
          return {
            ...item,
            isEditing: false,
          };
        }
        return item;
      });
    });
  };
  // 点击发送修改后的问题
  const handleSendEditorText = (itemData) => {
    setChatHistory((prev) => {
      return prev.map((item) => {
        if (item.msgId === itemData.msgId) {
          return {
            ...item,
            isEditing: false,
          };
        }
        return item;
      });
    });
    startChat(editorValue);
  };
  // 修改问题时输入框的值
  const handleChangeEditor = (e) => {
    setEditorValue(e.target.value);
  };
  // 移动端修改问题
  const handleClickEditorPhone = (itemData) => {
    setInputValue(itemData.content);
    inputRef.current?.focus();
  };

  // 点赞
  const handleClickLike = async (itemData) => {
    let params = {
      messageId: itemData.messageId,
      operation: itemData.like ? 0 : 1,
    };
    try {
      const response = await fetch(
        "https://chinapedia-test.goclouds.cn/chat/operation",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // 告诉后端传递的是 JSON
          },
          body: JSON.stringify(params),
        },
      );

      if (!response.ok) {
        console.log("请求失败");
      }

      const result = await response.json();
      if (result.code === 200) {
        setChatHistory((prev) => {
          return prev.map((item) => {
            if (item.msgId === itemData.msgId) {
              return {
                ...item,
                like: !item.like,
                downVote: false,
              };
            }
            return item;
          });
        });
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  // 点踩
  const handleClickDownVote = async (itemData) => {
    let params = {
      messageId: itemData.messageId,
      operation: itemData.downVote ? 0 : 2,
    };
    try {
      const response = await fetch(
        "https://chinapedia-test.goclouds.cn/chat/operation",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // 告诉后端传递的是 JSON
          },
          body: JSON.stringify(params),
        },
      );

      if (!response.ok) {
        console.log("请求失败");
      }
      const result = await response.json();
      if (result.code === 200) {
        setChatHistory((prev) => {
          return prev.map((item) => {
            if (item.msgId === itemData.msgId) {
              return {
                ...item,
                like: false,
                downVote: !item.downVote,
              };
            }
            return item;
          });
        });
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  // 点击播放音频
  const handlePlay = async (itemData) => {
    stopRecognition();
    // 如果正在播放当前条目 → 停止播放
    if (isPlayingMsgId(itemData.msgId)) {
      if (controllerRef.current) {
        controllerRef.current.abort(); // 停止流式请求
        controllerRef.current = null;
      }
      stopTTS();
      setChatHistory((prev) =>
        prev.map((msg) =>
          msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
        ),
      );
      return;
    }

    // 切换播放前先停掉旧的
    if (controllerRef.current) {
      controllerRef.current.abort();
      controllerRef.current = null;
    }
    stopTTS();
    setChatHistory((prev) =>
      prev.map((msg) =>
        msg.msgId === itemData.msgId
          ? { ...msg, isPlaying: true }
          : { ...msg, isPlaying: false },
      ),
    );

    if (itemData.history) {
      const controller = new AbortController();
      controllerRef.current = controller;
      fetchEventSource(
        // "https://Chinapedia.goclouds.cn/event/2025/Chinapedia-AI/chinapedia/chat/stream",
        `https://chinapedia-test.goclouds.cn/chat/stream-audio/${itemData.messageId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          signal: controller.signal,
          body: JSON.stringify({}),
          cache: "no-store",
          openWhenHidden: true,
          async onopen(event) {
            resumeTTS();
            setChatHistory((prev) =>
              prev.map((msg) =>
                msg.msgId === itemData.msgId
                  ? { ...msg, isPlaying: true }
                  : { ...msg, isPlaying: false },
              ),
            );
          },
          async onmessage(event) {
            if (event.data) {
              const audioUrl = base64ToBlobUrl(event.data, "audio/mp3");
              enqueueAudio(audioUrl, itemData.msgId);
            }
          },
          async onerror(event) {
            console.log("onerror", event);
          },
          async onclose(event) {
            controllerRef.current = null;
            resumeTTS();
          },
        },
      );
    } else {
      const urls =
        itemData.audioUrls && itemData.audioUrls.length > 0
          ? itemData.audioUrls
          : itemData.audioUrl
            ? [itemData.audioUrl]
            : [];

      if (urls.length === 0) return;

      // 检查 useAudioQueue 是否正在播放相同 msgId 的音频
      if (isPlayingMsgId(itemData.msgId)) {
        // 如果正在播放相同 msgId，则暂停队列播放并返回
        stopTTS();

        // 设置该条目的 isPlaying 为 false
        setChatHistory((prev) =>
          prev.map((msg) =>
            msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
          ),
        );
        return;
      }

      // 再次点击同一条目：若正在播放该条目的任一段，则停止并返回
      if (audioRef.current && currentPlaying && urls.includes(currentPlaying)) {
        stopTTS();
        audioRef.current.pause();
        audioRef.current = null;
        setCurrentPlaying(null);

        // 播放停止 → 该条 isPlaying = false
        setChatHistory((prev) =>
          prev.map((msg) =>
            msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
          ),
        );
        return;
      }

      // 切换到新条目播放前，停止其他播放
      stopTTS();
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }

      // 点击新条 → 该条 isPlaying = true，其它 isPlaying = false
      setChatHistory((prev) =>
        prev.map((msg) =>
          msg.msgId === itemData.msgId
            ? { ...msg, isPlaying: true }
            : { ...msg, isPlaying: false },
        ),
      );

      let idx = 0;
      const playNext = () => {
        if (idx >= urls.length) {
          setCurrentPlaying(null);
          audioRef.current = null;

          // 队列播放完毕 → 该条 isPlaying = false
          setChatHistory((prev) =>
            prev.map((msg) =>
              msg.msgId === itemData.msgId ? { ...msg, isPlaying: false } : msg,
            ),
          );
          return;
        }
        const url = urls[idx++];
        const audio = new Audio(url);
        audioRef.current = audio;
        setCurrentPlaying(url);
        audio.onended = playNext;
        audio.play().catch((err) => {
          console.error("播放失败:", err);
          playNext(); // 跳过损坏段
        });
      };

      playNext();
    }
  };

  // 切换语言
  const handleMenuClick = (e) => {
    const langConfig = {
      1: {
        langText: "中文",
        locale: "zh-CN",
      },
      2: {
        langText: "English",
        locale: "en-US",
      },
      3: {
        langText: "Español",
        locale: "es-ES",
      },
      4: {
        langText: "Français",
        locale: "fr-FR",
      },
      5: {
        langText: "Русский",
        locale: "ru-RU",
      },
      6: {
        langText: "العربية",
        locale: "ar-SA",
      },
    };
    if (langConfig[e.key]) {
      const { langText, locale } = langConfig[e.key];
      setLangText(langText);

      i18n.changeLanguage(locale);
      localStorage.setItem("language", locale);
    }
  };

  // 域名截取
  const getDomain = (url) => {
    try {
      const { origin } = new URL(url); // origin 包含协议 + 域名
      return origin; // https://www.gov.cn
    } catch (e) {
      return "";
    }
  };

  return (
    <>
      {isMobile ? (
        <div
          className="noselect page"
          style={{
            backdropFilter: chatHistory.length === 0 ? "none" : "blur(10px)",
          }}
          onClick={cancelShow}
        >
          {openSwitch ? (
            <div className="openLeftDiv">
              <div className="leftHerder">
                <div className="leftHerderTitle">{t("app.title")}</div>
                <img
                  onClick={changeSwitch}
                  className="switchOpenImg"
                  src={SwitchOpenIcon}
                />
              </div>
              <div className="btnContainer">
                <Button type="primary" icon={<CreateNewIcon />}>
                  {t("cta.create")}
                </Button>
              </div>
              <p className="chatHistoryTitle">{t("history.list.title")}</p>
            </div>
          ) : (
            <div className="leftDiv">
              <img
                onClick={changeSwitch}
                className="switchImg"
                src={SwitchCloseIcon}
              />
              <img className="createImg" src={CreateNewChat} />
            </div>
          )}
          <div
            className="rightDiv"
            style={{ width: openSwitch ? "71.17vw" : "95.8vw" }}
          >
            {chatHistory.length === 0 ? (
              <>
                <img
                  className="menuIcon"
                  onClick={showDrawer}
                  src={PhoneMenuIcon}
                />
                <div className="enterDiv">
                  <div>
                    <div className="enterText_title">{t("app.title")}</div>
                    <div className="enterText_tips">{t("app.subtitle")}</div>
                  </div>
                  <div className="enterInputDiv">
                    <div className="enterInputDiv_inputDiv">
                      <Input
                        className="enterInputDiv_input"
                        type="text"
                        placeholder={t("input.placeholder")}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onCompositionStart={() => setIsComposing(true)} // 中文输入开始
                        onCompositionEnd={() => setIsComposing(false)} // 中文输入结束
                        onPressEnter={(e) => {
                          if (e.key === "Enter" && !isComposing) {
                            e.preventDefault(); // 阻止默认换行
                            if (inputValue.trim()) {
                              startChat();
                              // setInputValue("");
                            }
                          }
                        }}
                        style={{
                          textAlign: current === "ar" ? "right" : "left",
                        }}
                      />
                    </div>
                    <div
                      className="enterInputDiv_button"
                      onClick={() => startChat()}
                      style={{ marginLeft: "10px" }}
                    >
                      <SendIcon />
                    </div>
                  </div>
                  <div className="enterInputDiv_tips">
                    {tipList.map((item) => (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          startChat(item.content);
                          // setInputValue("");
                        }}
                        key={item.id}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="page_footer">
                  {t("footer.terms")} <span>{t("footer.terms.label")}</span>{" "}
                  {t("and.text")} <span>{t("footer.privacy.label")}</span>
                </div>
              </>
            ) : (
              <>
                <div className="header">
                  <img
                    className="menuIcon"
                    onClick={showDrawer}
                    src={PhoneMenuIcon}
                  />
                  <div className="enterText_title1">{t("app.title")}</div>
                  <div
                    className="mobile_addIcon"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.location.reload();
                    }}
                  >
                    <AddIconMobile />
                  </div>
                </div>
                <div className="ChatDiv" ref={chatDivRef}>
                  {chatHistory.map((item, index) => {
                    return item.role === "system" ? (
                      <div className="agentMessage">
                        {item.content !== "" ? (
                          <>
                            <div class="agentBg">Pedia</div>
                            <div
                              className="agentMessage_content"
                              dir={item.language === "ar" ? "rtl" : "ltr"}
                            >
                              <ReactMarkdown
                                components={{ code: CodeBlock }}
                                children={item.content}
                              />
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {item?.isFinished && item.documents.length > 0 && (
                          <div className="sourceArticleContainer">
                            <p className="articleTitle">
                              {t("articles.source")}
                            </p>
                            <div className="articleBody">
                              <div className="referencesItemContainer">
                                {item.documents.length > 0 &&
                                  item.documents?.map((documentItem) => {
                                    return (
                                      <a
                                        href={documentItem.link}
                                        target="_blank"
                                      >
                                        <div className="referencesItem">
                                          {documentItem.img && (
                                            <img src={documentItem.img} />
                                          )}
                                          <p>{documentItem.title}</p>
                                        </div>
                                      </a>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        )}
                        {item.content && (
                          <div className="agentMessage_Tool">
                            {item?.audioUrl && (
                              <div onClick={() => handlePlay(item)}>
                                <img
                                  src={
                                    item?.isPlaying ? RecordingIcon : PlayIcon
                                  }
                                />
                              </div>
                            )}
                            <div
                              onClick={(e) => {
                                e.stopPropagation();

                                if (
                                  navigator.clipboard &&
                                  navigator.clipboard.writeText
                                ) {
                                  // 现代浏览器 & https/localhost 环境
                                  navigator.clipboard
                                    .writeText(item.content)
                                    .then(() => {
                                      message.success({
                                        content: t("toast.copied"),
                                      });
                                    })
                                    .catch((err) => {
                                      console.error("复制失败:", err);
                                      fallbackCopyText(item.content);
                                    });
                                } else {
                                  // 旧环境 / http 下 fallback
                                  fallbackCopyText(item.content);
                                }
                              }}
                            >
                              <CopyIcon />
                            </div>
                            {index === chatHistory.length - 1 && !isLoading && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsLoading(true);
                                  startChat(
                                    chatHistory[index - 1].content,
                                    "refresh",
                                  );
                                }}
                              >
                                <FreshIcon />
                              </div>
                            )}
                            <div onClick={(e) => showShareModalPhone(e, item)}>
                              <img src={ShareIcon} />
                            </div>
                            <div onClick={() => handleClickLike(item)}>
                              <img
                                src={item?.like ? LikeActiveIcon : LikeIcon}
                              />
                            </div>
                            <div onClick={() => handleClickDownVote(item)}>
                              <img
                                src={
                                  item?.downVote
                                    ? DownVoteActiveIcon
                                    : UnLikeIcon
                                }
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="customerContainer">
                        <div className="customerMessage">
                          <div dir={item.language === "ar" ? "rtl" : "ltr"}>
                            {item.content}
                          </div>
                          <CustomerIcon />
                        </div>
                        <div className="customerMessage_Tool">
                          <div>
                            <img
                              onClick={() => handleClickEditorPhone(item)}
                              src={EditorIcon}
                            />
                          </div>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();

                              if (
                                navigator.clipboard &&
                                navigator.clipboard.writeText
                              ) {
                                // 现代浏览器 & https/localhost 环境
                                navigator.clipboard
                                  .writeText(item.content)
                                  .then(() => {
                                    message.success({
                                      content: t("toast.copied"),
                                    });
                                  })
                                  .catch((err) => {
                                    console.error("复制失败:", err);
                                    fallbackCopyText(item.content);
                                  });
                              } else {
                                // 旧环境 / http 下 fallback
                                fallbackCopyText(item.content);
                              }
                            }}
                          >
                            <CopyIcon />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {isLoading &&
                    (() => {
                      const last = chatHistory[chatHistory.length - 1];
                      return (
                        (last?.role === "system" && !last?.content) ||
                        last?.role !== "system"
                      );
                    })() && <div className="loader"></div>}
                </div>
                <div className="ChatDiv_Input">
                  <div className="ChatDiv_Input_mobile">
                    {tipList.map((item) => (
                      <div
                        className="chatInput_button_item"
                        onClick={(e) => {
                          e.stopPropagation();
                          startChat(item.content);
                          // setInputValue("");
                        }}
                        key={item.id}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                  <div
                    className="ChatDiv_newChat"
                    onClick={(e) => {
                      e.stopPropagation();
                      // 刷新页面
                      window.location.reload();
                    }}
                  >
                    <AddIcon />
                    <span>{t("cta.create")}</span>
                  </div>
                  <div className="enterInputDiv chatInputDiv">
                    <div
                      className="enterInputDiv_inputDiv"
                      style={{
                        width: "100%",
                        height: "85%",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="chatInput">
                        <TextArea
                          ref={inputRef}
                          autoSize={{ minRows: 4, maxRows: 4 }}
                          className="chatInput_input"
                          type="text"
                          placeholder={t("input.placeholder")}
                          value={inputValue}
                          onChange={(e) => setInputValue(e.target.value)}
                          onCompositionStart={() => setIsComposing(true)} // 中文输入开始
                          onCompositionEnd={() => setIsComposing(false)} // 中文输入结束
                          onPressEnter={(e) => {
                            if (e.key === "Enter" && !isComposing) {
                              e.preventDefault(); // 阻止默认换行
                              if (inputValue.trim()) {
                                startChat();
                                // setInputValue("");
                              }
                            }
                          }}
                          style={{
                            textAlign: current === "ar" ? "right" : "left",
                          }}
                        />
                        <div className="chatInput_button">
                          <div
                            className="enterInputDiv_tips"
                            style={{
                              marginTop: 0,
                              maxWidth: "70%",
                              minWidth: "70%",
                              overflowY: "auto",
                              justifyContent: "flex-start",
                              marginLeft: "11px",
                            }}
                          >
                            {tipList.map((item) => (
                              <div
                                className="chatInput_button_item"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  startChat(item.content);
                                  // setInputValue("");
                                }}
                                key={item.id}
                              >
                                {item.title}
                              </div>
                            ))}
                          </div>
                          {isLoading ? (
                            <div
                              className="enterInputDiv_button"
                              onClick={pauseChat}
                              style={{
                                width: "32px",
                                height: "32px",
                              }}
                            >
                              <img
                                style={{ width: "32px", height: "32px" }}
                                src={PauseIcon}
                              />
                            </div>
                          ) : (
                            <div
                              className="enterInputDiv_button"
                              onClick={() => startChat()}
                              style={{
                                width: "32px",
                                height: "32px",
                                // marginRight: "5px",
                              }}
                            >
                              <SendIconSmall />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <Modal
            wrapClassName="shareModalPhone"
            open={shareModalOpenPhone}
            onCancel={hideShareModalPhone}
          >
            <div className="shareTitle">
              <i></i>
              {t("cta.share")}
            </div>
            <div className="shareContainer">
              {shareAgentData?.map((itemData) => {
                if (itemData.role === "user") {
                  return (
                    <div
                      className="customerMessage"
                      style={{ marginBottom: "20px" }}
                    >
                      <div className="customerText">{itemData?.content}</div>
                      <CustomerIcon />
                    </div>
                  );
                } else {
                  return (
                    <div className="agentMessage">
                      <div class="agentBg">Pedia</div>
                      <div
                        className="agentMessage_content"
                        dir={itemData.language === "ar" ? "rtl" : "ltr"}
                      >
                        <ReactMarkdown
                          components={{ code: CodeBlock }}
                          children={itemData?.content}
                        />
                      </div>
                    </div>
                  );
                }
              })}
            </div>
            <div className="btnDiv">
              <Button
                onClick={handleCopy}
                className="copyBtn"
                icon={<LinkIcon />}
                type="primary"
              >
                {t("cta.copy")}
              </Button>
            </div>
          </Modal>

          <Drawer
            title={null}
            placement="left"
            open={drawerOpen}
            onClose={onClose}
          >
            <div className="leftHerder">
              <div className="leftHerderTitle">{t("app.title")}</div>
              <img
                onClick={onClose}
                className="closeReturnIcon"
                src={PhoneReturnIcon}
              />
            </div>
            <div className="phoneListContainer">
              <div className="chatHistoryListContainer">
                {historyList?.map((historyItem) => {
                  const isOpen = openPopoverId === historyItem.chatId;
                  return (
                    <div
                      className={
                        historyItem.chatId === chatIdSelect
                          ? "listItemSelected"
                          : "listItem"
                      }
                    >
                      <p
                        title={historyItem.title}
                        style={{
                          textAlign: current === "ar" ? "right" : "left",
                        }}
                        onClick={() => handleSelectChat(historyItem)}
                      >
                        {historyItem.title}
                      </p>
                      <Popover
                        placement="bottomLeft"
                        content={
                          <div className="operationContainer">
                            <p
                              onClick={() =>
                                changeEditorStatusPhone(historyItem)
                              }
                              className="operationItem"
                            >
                              <img src={EditorIcon} />
                              <span>{t("ui.rename")}</span>
                            </p>
                            <p
                              onClick={() => handleDeleteChat(historyItem)}
                              className="deleteItem"
                            >
                              <img src={DeleteIcon} />
                              <span>{t("ui.delete")}</span>
                            </p>
                          </div>
                        }
                        open={isOpen}
                        onOpenChange={(open) => {
                          setOpenPopoverId(open ? historyItem.chatId : null);
                        }}
                        trigger="click"
                      >
                        <img
                          style={{
                            marginLeft: current === "ar" ? "5px" : "0px",
                          }}
                          src={MoreIcon}
                        />
                      </Popover>
                    </div>
                  );
                })}
              </div>
            </div>
            <LanguageSwitcher />

            <Modal
              wrapClassName="editorModalPhone"
              open={isModalOpen}
              closable={false}
            >
              <p
                style={{ textAlign: current === "ar" ? "right" : "left" }}
                className="modalTitle"
              >
                <i
                  style={{
                    float: current === "ar" ? "right" : "left",
                    marginLeft: current === "ar" ? "15px" : "0px",
                  }}
                ></i>
                {t("editor.name.phone")}
              </p>
              <Input
                value={nameValue}
                className="phoneInput"
                onChange={handleChangeName}
                style={{ textAlign: current === "ar" ? "right" : "left" }}
              />
              <div className="modalFooter">
                <div onClick={handleCancel} className="leftFooter">
                  {t("btn.cancel")}
                </div>
                <div onClick={handleOk} className="rightFooter">
                  {t("btn.ok")}
                </div>
              </div>
            </Modal>
          </Drawer>

          {/*删除对话提示弹窗*/}
          <Modal
            style={{ textAlign: current === "ar" ? "right" : "left" }}
            wrapClassName="deleteModalPc"
            footer={null}
            title={t("delete.chat.title")}
            open={deleteModal}
            onCancel={handleCloseDelete}
          >
            <p style={{ textAlign: current === "ar" ? "right" : "left" }}>
              {t("delete.chat.tips.text")}
            </p>
            <div className="btn">
              <Button onClick={handleCloseDelete}>{t("btn.cancel")}</Button>
              <Button onClick={handleDelete} danger>
                {t("ui.delete")}
              </Button>
            </div>
          </Modal>
        </div>
      ) : (
        <div
          className="page"
          style={{
            backdropFilter: chatHistory.length === 0 ? "none" : "blur(10px)",
          }}
          onClick={cancelShow}
        >
          {openSwitch ? (
            <div className="openLeftDiv">
              <div className="leftHerder">
                <div className="leftHerderTitle">{t("app.title")}</div>
                <img
                  onClick={changeSwitch}
                  className="switchOpenImg"
                  src={SwitchOpenIcon}
                />
              </div>
              <div className="btnContainer">
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    // 刷新页面
                    window.location.reload();
                  }}
                  type="primary"
                  icon={<CreateNewIcon />}
                >
                  {t("cta.create")}
                </Button>
              </div>
              <p
                className="chatHistoryTitle"
                style={{ textAlign: langText === "العربية" ? "right" : "left" }}
              >
                {t("history.list.title")}
              </p>
              <div className="chatHistoryListContainer">
                {historyList?.map((historyItem) => {
                  return (
                    <>
                      {historyItem.editorStatus ? (
                        <div className="listItemInput">
                          <Input
                            value={nameValue}
                            onChange={handleChangeName}
                            onPressEnter={(e) => onPressEnter(e, historyItem)}
                            style={{
                              textAlign:
                                langText === "العربية" ? "right" : "left",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          className={
                            historyItem.chatId === chatIdSelect
                              ? "listItemSelected"
                              : "listItem"
                          }
                        >
                          <p
                            title={historyItem.title}
                            style={{
                              textAlign:
                                langText === "العربية" ? "right" : "left",
                            }}
                            onClick={() => handleSelectChat(historyItem)}
                          >
                            {historyItem.title}
                          </p>
                          <Popover
                            placement="bottomLeft"
                            content={
                              <div className="operationContainer">
                                <p
                                  onClick={() =>
                                    changeEditorStatus(historyItem)
                                  }
                                  className="operationItem"
                                >
                                  <img src={EditorIcon} />
                                  <span>{t("ui.rename")}</span>
                                </p>
                                <p
                                  onClick={() => handleDeleteChat(historyItem)}
                                  className="deleteItem"
                                >
                                  <img src={DeleteIcon} />
                                  <span>{t("ui.delete")}</span>
                                </p>
                              </div>
                            }
                            trigger="click"
                          >
                            <img src={MoreIcon} />
                          </Popover>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="leftDiv">
              <img
                onClick={changeSwitch}
                className="switchImg"
                src={SwitchCloseIcon}
              />
              <img
                className="createImg"
                src={CreateNewChat}
                onClick={(e) => {
                  e.stopPropagation();
                  // 刷新页面
                  window.location.reload();
                }}
              />
            </div>
          )}
          <div
            className="rightDiv"
            style={{ width: openSwitch ? "83.12vw" : "95.8vw" }}
          >
            <div class="languageContainer">
              <Dropdown
                menu={{
                  items,
                  selectable: true,
                  defaultSelectedKeys: [defaultSelectedKeys],
                  onClick: handleMenuClick,
                }}
                overlayClassName="langDownPersonal"
              >
                <div>
                  <img src={LanguageIcon} />
                  <span>{langText}</span>
                </div>
              </Dropdown>
            </div>
            {chatHistory.length === 0 ? (
              <>
                <img
                  className="menuIcon"
                  onClick={showDrawer}
                  src={PhoneMenuIcon}
                />
                <div className="enterDiv">
                  <div>
                    <div className="enterText_title">{t("app.title")}</div>
                    <div className="enterText_tips">{t("app.subtitle")}</div>
                  </div>
                  <div className="enterInputDiv">
                    <div className="enterInputDiv_inputDiv">
                      <Input
                        className="enterInputDiv_input"
                        type="text"
                        placeholder={t("input.placeholder")}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onCompositionStart={() => setIsComposing(true)} // 中文输入开始
                        onCompositionEnd={() => setIsComposing(false)} // 中文输入结束
                        onPressEnter={(e) => {
                          if (e.key === "Enter" && !isComposing) {
                            e.preventDefault(); // 阻止默认换行
                            if (inputValue.trim()) {
                              startChat();
                              // setInputValue("");
                            }
                          }
                        }}
                        style={{
                          textAlign: langText === "العربية" ? "right" : "left",
                        }}
                      />
                    </div>
                    <div
                      className="enterInputDiv_button"
                      onClick={() => startChat()}
                      style={{ marginLeft: "10px" }}
                    >
                      <SendIcon />
                    </div>
                  </div>
                  <div className="enterInputDiv_tips">
                    {tipList.map((item) => (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          startChat(item.content);
                          // setInputValue("");
                        }}
                        key={item.id}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="page_footer">
                  {t("footer.terms")} <span>{t("footer.terms.label")}</span>{" "}
                  {t("and.text")} <span>{t("footer.privacy.label")}</span>
                </div>
              </>
            ) : (
              <>
                <div className="header">
                  <img
                    className="menuIcon"
                    onClick={showDrawer}
                    src={PhoneMenuIcon}
                  />
                  <div className="enterText_title1">{t("app.title")}</div>
                  <div
                    className="mobile_addIcon"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.location.reload();
                    }}
                  >
                    <AddIconMobile />
                  </div>
                </div>
                <div className="ChatDiv" ref={chatDivRef}>
                  {chatHistory.map((item, index) => {
                    return (
                      <>
                        {item.role === "system" ? (
                          <div className="agentMessage">
                            {item.content !== "" ? (
                              <>
                                <div class="agentBg">Pedia</div>
                                <div
                                  className="agentMessage_content"
                                  dir={item.language === "ar" ? "rtl" : "ltr"}
                                >
                                  <ReactMarkdown
                                    components={{ code: CodeBlock }}
                                    children={item.content}
                                  />
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                            {item.documents.length > 0 && item.content && (
                              <div className="referencesContainer">
                                <p className="referencesTitle">
                                  <img src={ReferencesIcon} />
                                  {t("articles.source")}
                                </p>
                                <div className="referencesItemBody">
                                  <div className="referencesItemContainer">
                                    {item.documents.length > 0 &&
                                      item.documents?.map((documentItem) => {
                                        return (
                                          <a
                                            href={documentItem.link}
                                            target="_blank"
                                          >
                                            <div className="referencesItem">
                                              <div className="referencesItemTop">
                                                {documentItem.img && (
                                                  <img src={documentItem.img} />
                                                )}
                                                <p>{documentItem.title}</p>
                                              </div>
                                              <div className="referencesItemBottom">
                                                {documentItem.time}
                                                <p
                                                  title={getDomain(
                                                    documentItem.link,
                                                  )}
                                                  class="textHttps"
                                                >
                                                  {getDomain(documentItem.link)}
                                                </p>
                                              </div>
                                            </div>
                                          </a>
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.content && (
                              <div className="agentMessage_Tool">
                                {item?.audioUrl && (
                                  <div onClick={() => handlePlay(item)}>
                                    <img
                                      src={
                                        item?.isPlaying
                                          ? RecordingIcon
                                          : PlayIcon
                                      }
                                    />
                                  </div>
                                )}
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    if (
                                      navigator.clipboard &&
                                      navigator.clipboard.writeText
                                    ) {
                                      // 现代浏览器 & https/localhost 环境
                                      navigator.clipboard
                                        .writeText(item.content)
                                        .then(() => {
                                          message.success({
                                            content: t("toast.copied"),
                                          });
                                        })
                                        .catch((err) => {
                                          console.error("复制失败:", err);
                                          fallbackCopyText(item.content);
                                        });
                                    } else {
                                      // 旧环境 / http 下 fallback
                                      fallbackCopyText(item.content);
                                    }
                                  }}
                                >
                                  <CopyIcon />
                                </div>
                                {index === chatHistory.length - 1 &&
                                  !isLoading && (
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setIsLoading(true);
                                        startChat(
                                          chatHistory[index - 1].content,
                                          "refresh",
                                        );
                                      }}
                                    >
                                      <FreshIcon />
                                    </div>
                                  )}
                                <div>
                                  <img
                                    onClick={(e) =>
                                      showShareModalPhone(e, item)
                                    }
                                    src={ShareIcon}
                                  />
                                </div>
                                <div onClick={() => handleClickLike(item)}>
                                  <img
                                    src={item?.like ? LikeActiveIcon : LikeIcon}
                                  />
                                </div>
                                <div onClick={() => handleClickDownVote(item)}>
                                  <img
                                    src={
                                      item?.downVote
                                        ? DownVoteActiveIcon
                                        : UnLikeIcon
                                    }
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="customerContainer">
                            <div className="customerMessage">
                              {item?.isEditing ? (
                                <div className="editorContainer">
                                  <img
                                    onClick={() => handleCloseEditor(item)}
                                    src={CloseIcon}
                                  />
                                  <TextArea
                                    autoSize={{ minRows: 2, maxRows: 2 }}
                                    type="text"
                                    value={editorValue}
                                    onChange={handleChangeEditor}
                                    dir={item.language === "ar" ? "rtl" : "ltr"}
                                  />
                                  <div
                                    className="enterInputDiv_button"
                                    onClick={() => handleSendEditorText(item)}
                                  >
                                    <SendIconSmall />
                                  </div>
                                </div>
                              ) : (
                                <div
                                  className="customerText"
                                  dir={item.language === "ar" ? "rtl" : "ltr"}
                                >
                                  {item.content}
                                </div>
                              )}
                              <CustomerIcon />
                            </div>
                            {!item?.isEditing && (
                              <div className="customerMessage_Tool">
                                <div>
                                  <img
                                    onClick={() => handleClickEditor(item)}
                                    src={EditorIcon}
                                  />
                                </div>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    if (
                                      navigator.clipboard &&
                                      navigator.clipboard.writeText
                                    ) {
                                      // 现代浏览器 & https/localhost 环境
                                      navigator.clipboard
                                        .writeText(item.content)
                                        .then(() => {
                                          message.success({
                                            content: t("toast.copied"),
                                          });
                                        })
                                        .catch((err) => {
                                          console.error("复制失败:", err);
                                          fallbackCopyText(item.content);
                                        });
                                    } else {
                                      // 旧环境 / http 下 fallback
                                      fallbackCopyText(item.content);
                                    }
                                  }}
                                >
                                  <CopyIcon />
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    );
                  })}
                  {isLoading &&
                    (() => {
                      const last = chatHistory[chatHistory.length - 1];
                      return (
                        (last?.role === "system" && !last?.content) ||
                        last?.role !== "system"
                      );
                    })() && <div className="loader"></div>}
                </div>
                <div className="ChatDiv_Input">
                  <div className="ChatDiv_Input_mobile">
                    {tipList.map((item) => (
                      <div
                        className="chatInput_button_item"
                        onClick={(e) => {
                          e.stopPropagation();
                          startChat(item.content);
                          // setInputValue("");
                        }}
                        key={item.id}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                  <div className="enterInputDiv chatInputDiv">
                    <div
                      className="enterInputDiv_inputDiv"
                      style={{
                        width: "100%",
                        height: "85%",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="chatInput">
                        <TextArea
                          ref={inputRef}
                          autoSize={{ minRows: 4, maxRows: 4 }}
                          className="chatInput_input"
                          type="text"
                          placeholder={t("input.placeholder")}
                          value={inputValue}
                          onChange={(e) => setInputValue(e.target.value)}
                          onCompositionStart={() => setIsComposing(true)} // 中文输入开始
                          onCompositionEnd={() => setIsComposing(false)} // 中文输入结束
                          onPressEnter={(e) => {
                            if (e.key === "Enter" && !isComposing) {
                              e.preventDefault(); // 阻止默认换行
                              if (inputValue.trim()) {
                                startChat();
                                // setInputValue("");
                              }
                            }
                          }}
                          style={{
                            textAlign:
                              langText === "العربية" ? "right" : "left",
                          }}
                        />
                        <div className="chatInput_button">
                          <div
                            className="enterInputDiv_tips"
                            style={{
                              marginTop: 0,
                              maxWidth: "70%",
                              minWidth: "70%",
                              overflowY: "auto",
                              justifyContent: "flex-start",
                              marginLeft: "11px",
                            }}
                          >
                            {tipList.map((item) => (
                              <div
                                className="chatInput_button_item"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  startChat(item.content);
                                  // setInputValue("");
                                }}
                                key={item.id}
                              >
                                {item.title}
                              </div>
                            ))}
                          </div>
                          <div className="enterInputDivRight">
                            {isLoading ? (
                              <div
                                className="enterInputDiv_button"
                                onClick={pauseChat}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                }}
                              >
                                <img
                                  style={{ width: "32px", height: "32px" }}
                                  src={PauseIcon}
                                />
                              </div>
                            ) : (
                              <div
                                className="enterInputDiv_button"
                                onClick={() => startChat()}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  // marginRight: "5px",
                                }}
                              >
                                <SendIconSmall />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <Modal
            mask={false}
            footer={null}
            wrapClassName="shareModalPC"
            open={shareModalOpenPhone}
            onCancel={hideShareModalPhone}
          >
            <div className="shareTitle">
              <i></i>
              {t("cta.share")}
            </div>
            <div className="shareContainer">
              {shareAgentData?.map((itemData) => {
                if (itemData.role === "user") {
                  return (
                    <div
                      className="customerMessage"
                      style={{ marginBottom: "20px" }}
                    >
                      <div className="customerText">{itemData?.content}</div>
                      <CustomerIcon />
                    </div>
                  );
                } else {
                  return (
                    <div className="agentMessage">
                      <div class="agentBg">Pedia</div>
                      <div
                        className="agentMessage_content"
                        dir={itemData.language === "ar" ? "rtl" : "ltr"}
                      >
                        <ReactMarkdown
                          components={{ code: CodeBlock }}
                          children={itemData?.content}
                        />
                      </div>
                    </div>
                  );
                }
              })}
            </div>
            <div className="btnDiv">
              <Button
                onClick={handleCopy}
                className="copyBtn"
                icon={<LinkIcon />}
                type="primary"
              >
                {" "}
                {t("cta.copy")}
              </Button>
            </div>
          </Modal>
          {/*删除对话提示弹窗*/}
          <Modal
            style={{ textAlign: langText === "العربية" ? "right" : "left" }}
            wrapClassName="deleteModalPc"
            footer={null}
            title={t("delete.chat.title")}
            open={deleteModal}
            onCancel={handleCloseDelete}
          >
            <p style={{ textAlign: langText === "العربية" ? "right" : "left" }}>
              {t("delete.chat.tips.text")}
            </p>
            <div className="btn">
              <Button onClick={handleCloseDelete}>{t("btn.cancel")}</Button>
              <Button onClick={handleDelete} danger>
                {t("ui.delete")}
              </Button>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default PC;
